import { useEffect, useState } from "react";
import LoadingStuck from "../../../reuse/LoadingStuck";
import { useParams } from "react-router";
import Api, { BaseUrl } from "../../../../api/Api";
import { Accordion, Button, Card, Col, Row, Stack, Table } from "react-bootstrap";
import downloadJsonFile from "../../../reuse/downloadJsonFile";

const TestTaskBlock = ({data, block_label})=>{
    const tasks=Object.keys(data);
    return(
        <>
        <div className="m-1">
        <h5>Уровень {block_label}</h5>
        </div>
        <div>
        {tasks.map((item)=>(
            <Card key={`card ${item}`} className="mb-1">
                <Card.Header className="text_font">{`№${item} -- ${data[item]["additional_info"]["index"]}`}</Card.Header>
                <Card.Body className="text_font">
                    <div><strong>Текст задания:</strong> {data[item]["task_value"] || "Не указано"}</div>
                    <div><strong>Контрольный элемент:</strong> {data[item]["control_element"] || "Не указано"}</div>
                    <div><strong>Ответственный:</strong> {data[item]["additional_info"]["accountable"] || "Не указано"}</div>
                    <div><strong>Формат ответа:</strong> {data[item]["answer_label"] || "Не указано"}</div>
                    <div><strong>Тип ответа:</strong> {data[item]["answer_type_attributes"] || "Не указано"}</div>
                </Card.Body>
            </Card>
        ))}
        </div>
        </>
    )
}

const TestLevelBlock = ({data})=> {
    const part=Object.keys(data)
    const [currentBlock,setCurrentBlock]=useState(part[0])
    const renderComponent = () => {
        const data_category=data[currentBlock]
        return(<TestTaskBlock data={data_category} block_label={currentBlock}/>)
    }
    return(<>
    <div>
        {part.map((item,index)=>(<Button className="m-1" onClick={() => setCurrentBlock(item)}>Уровень {item}</Button>))}
    </div>
    <div>
        {renderComponent()}
    </div>
    </>)
}

const TestCategoryBlock = ({data, block_label}) => {
    const part=Object.keys(data)
    const [currentBlock,setCurrentBlock]=useState(part[0])
    const renderComponent = () => {
        const data_category=data[currentBlock]
        return(<>{JSON.stringify(data_category)}</>)
    }
    return(
    <>
    <div className="mt-1 mb-1"><h5>{block_label}</h5></div>
    <div>
        {part.map((item, index)=>(
            <Accordion className="mb-1 border">
                <Accordion.Header><div className="text_font">{index+1}.{item}</div></Accordion.Header>
                <Accordion.Body><TestLevelBlock data={data[item]}/></Accordion.Body>
            </Accordion>
        ))}
    </div>
    </>)
}


const TestStructureInterface = ({data}) => {
    const part=Object.keys(data)
    const [currentBlock,setCurrentBlock]=useState(part[0])
    const renderComponent = () => {
        const data_category=data[currentBlock]
        return(<TestCategoryBlock data={data_category} block_label={currentBlock}/>)
    }
    return(
        <>
        <div>
            <Row>
                {part.map((item,index) => (
                    <Col key={`col item ${index}`} md={3} className="mb-1">
                        <Button 
                        key={item} 
                        className="m-1 free-btn" 
                        onClick={() => setCurrentBlock(item)}>{item}</Button>
                    </Col>))}
            </Row>
        </div>
        <div>
            {renderComponent()}
        </div>
        </>
    )
}

const AdminTestStructureInterface = ({data})=>{
    return(<>
        <Card className="mt-1 mb-2">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div className="text_font">Информация о тесте.</div>
                    <div>
                        <Button onClick={()=>{downloadJsonFile(data, `${data.name}.json`)}}>Скачать тест</Button>
                    </div>
                </div>
            </Card.Header>
            <Card.Body className="text_font">
                <div><strong>Название:</strong> {data.name}</div>
                <div><strong>id:</strong> {data.id}</div>
                <div><strong>Дата создания:</strong> {new Date(data.created_at).toLocaleString()}</div>
                <div><strong>Описание:</strong> {data.description}</div>
                <div><strong>Коэфициенты разделов:</strong></div>
                <Table 
                    striped="columns" 
                    bordered 
                    hover 
                    size="sm" 
                    className="mt-1"
                    responsive
                    >
                    <thead>
                        <tr>
                        {Object.keys(data.coefficients).map(item=>(<th key={item}>{item}</th>))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                        {Object.values(data.coefficients).map((item, index)=>(<td key={`item ${index}`}>{item}</td>))}
                        </tr>
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
        <div className="mt-1">
            <TestStructureInterface data={data.data}/>
        </div>
    </>)
}

const AdminTestStructureFetch = () => {
    const [loading, setLoading]=useState(false);
    const [error, setError]=useState(false);
    const [block, setBlock]=useState(false);

    const [data, setData]=useState(null);
    const [errorInfo, setErrorInfo]=useState(null);

    const {test_id}=useParams()

    const getTestInfo = async(test_id) => {
        try {
            const response = await Api({
                method:"get",
                url:`/tests/@${test_id}`,
                headers:{}
            })
            setBlock(true);
            setData(response.data)
        } catch (error) {
            // setErrorInfo(`Ошибка при получении информации о тесте ${test_id}`);
            setErrorInfo(`Ошибка при получении информации о тесте ${test_id} \n ${error}`)
            setError(true);
        }
    }

    useEffect(()=>{
        const setup = async() => {
            setLoading(true)
            await getTestInfo(test_id);
            setLoading(false)
        };
        setup();
    },[])

    if(loading){return(<LoadingStuck/>)}
    if(error){return(<><p className="warning_text sepatate_text">{errorInfo}</p></>)}
    if(block){return(<><AdminTestStructureInterface data={data}/></>)}
}

const AdminTestStructureBlock = () => {
    return(<AdminTestStructureFetch/>)
}

export default AdminTestStructureBlock;